import React from "react";
import { withFadeTransition } from "../../../../StoreComponents/StoreTransition";
import ExpiringRewardList from "./components/ExpiringRewardList";

const Expiring = () => {
  return <ExpiringRewardList />;
};

export default withFadeTransition(Expiring);
